import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "phone-number-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "phone-number-loaded bsp-page__content"
}
const _hoisted_3 = {
  key: 0,
  class: "bsp-section bsp-catalog-template-notice",
  "aria-label": "Connected product catalog"
}
const _hoisted_4 = {
  key: 0,
  role: "status"
}
const _hoisted_5 = {
  key: 1,
  role: "alert"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = {
  key: 4,
  role: "status"
}
const _hoisted_11 = {
  key: 5,
  role: "alert"
}
const _hoisted_12 = {
  key: 6,
  role: "alert"
}
const _hoisted_13 = { key: 7 }
const _hoisted_14 = {
  key: 8,
  role: "status"
}
const _hoisted_15 = { class: "bsp-component-actions" }
const _hoisted_16 = { class: "message-templates-and-creation" }
const _hoisted_17 = { class: "message-templates bsp-section" }
const _hoisted_18 = { class: "phone-number" }
const _hoisted_19 = { class: "message-template-container" }
const _hoisted_20 = { class: "bsp-section-heading" }
const _hoisted_21 = {
  key: 0,
  class: "message-template-list"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "message-template-name" }
const _hoisted_24 = { class: "message-template-status" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "message-template-actions" }
const _hoisted_27 = {
  key: 0,
  class: "bsp-template-test",
  "aria-labelledby": "template-test-title"
}
const _hoisted_28 = { class: "bsp-template-test__heading" }
const _hoisted_29 = { class: "bsp-template-test__workspace" }
const _hoisted_30 = { class: "bsp-template-preview-panel" }
const _hoisted_31 = { class: "bsp-template-panel-heading" }
const _hoisted_32 = { class: "bsp-whatsapp-preview" }
const _hoisted_33 = { class: "bsp-whatsapp-preview__brand" }
const _hoisted_34 = { class: "bsp-whatsapp-preview__bubble" }
const _hoisted_35 = { class: "bsp-template-preview__header" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = {
  key: 1,
  class: "bsp-template-media-placeholder",
  role: "status"
}
const _hoisted_38 = { class: "bsp-template-catalog-summary" }
const _hoisted_39 = {
  key: 0,
  class: "bsp-template-preview__header"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "bsp-template-media-placeholder" }
const _hoisted_42 = {
  key: 1,
  class: "bsp-template-media-placeholder"
}
const _hoisted_43 = { key: 2 }
const _hoisted_44 = {
  key: 1,
  class: "bsp-template-preview__body"
}
const _hoisted_45 = {
  key: 2,
  class: "bsp-template-preview__footer"
}
const _hoisted_46 = {
  key: 3,
  class: "bsp-template-preview__button"
}
const _hoisted_47 = {
  key: 0,
  class: "bsp-template-variable-group"
}
const _hoisted_48 = {
  key: 0,
  class: "bsp-template-field-caption"
}
const _hoisted_49 = {
  key: 1,
  class: "bsp-template-field-caption"
}
const _hoisted_50 = {
  key: 2,
  role: "alert"
}
const _hoisted_51 = {
  key: 3,
  role: "alert"
}
const _hoisted_52 = { class: "bsp-component-actions" }
const _hoisted_53 = {
  key: 4,
  role: "alert"
}
const _hoisted_54 = { class: "bsp-template-variables-panel" }
const _hoisted_55 = { class: "bsp-template-panel-heading" }
const _hoisted_56 = {
  key: 0,
  class: "bsp-template-no-variables"
}
const _hoisted_57 = {
  key: 0,
  class: "bsp-template-variable-group"
}
const _hoisted_58 = {
  key: 1,
  class: "bsp-template-variable-stack"
}
const _hoisted_59 = {
  key: 2,
  class: "bsp-template-variable-stack"
}
const _hoisted_60 = {
  key: 3,
  class: "bsp-template-variable-stack"
}
const _hoisted_61 = {
  key: 4,
  class: "bsp-template-location-grid"
}
const _hoisted_62 = {
  key: 1,
  class: "bsp-template-variable-group"
}
const _hoisted_63 = {
  key: 2,
  class: "bsp-template-variable-group"
}
const _hoisted_64 = { class: "bsp-template-recipient" }
const _hoisted_65 = {
  class: "bsp-template-recipient__icon",
  "aria-hidden": "true"
}
const _hoisted_66 = { class: "message-template-creator bsp-section" }
const _hoisted_67 = { class: "message-template-creation-form" }
const _hoisted_68 = {
  key: 0,
  class: "bsp-template-component-note"
}
const _hoisted_69 = { class: "message-template-components" }
const _hoisted_70 = {
  key: 0,
  class: "message-template-component-header"
}
const _hoisted_71 = { class: "bsp-template-component-heading" }
const _hoisted_72 = { class: "bsp-template-component-heading__copy" }
const _hoisted_73 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_74 = {
  key: 1,
  class: "bsp-template-parameter-list"
}
const _hoisted_75 = {
  key: 3,
  class: "bsp-template-component-note"
}
const _hoisted_76 = {
  key: 1,
  class: "message-template-component-body"
}
const _hoisted_77 = { class: "bsp-template-component-heading" }
const _hoisted_78 = { class: "bsp-template-component-heading__copy" }
const _hoisted_79 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_80 = {
  key: 0,
  class: "bsp-template-parameter-list"
}
const _hoisted_81 = {
  key: 2,
  class: "message-template-component-button"
}
const _hoisted_82 = { class: "bsp-template-component-heading" }
const _hoisted_83 = { class: "bsp-template-component-heading__copy" }
const _hoisted_84 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_85 = {
  key: 0,
  class: "bsp-template-component-note"
}
const _hoisted_86 = {
  key: 1,
  class: "bsp-template-button-list"
}
const _hoisted_87 = { class: "bsp-template-button-editor__heading" }
const _hoisted_88 = {
  key: 2,
  class: "bsp-template-component-note"
}
const _hoisted_89 = {
  key: 3,
  class: "bsp-component-actions bsp-component-actions--buttons"
}
const _hoisted_90 = {
  key: 3,
  class: "message-template-component-footer"
}
const _hoisted_91 = { class: "bsp-template-component-heading" }
const _hoisted_92 = { class: "bsp-template-component-heading__copy" }
const _hoisted_93 = {
  class: "bsp-template-component-icon",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "bsp-template-component-picker" }
const _hoisted_95 = { class: "bsp-component-actions" }
const _hoisted_96 = {
  key: 4,
  class: "bsp-template-components-complete"
}
const _hoisted_97 = {
  key: 1,
  class: "bsp-template-component-note",
  role: "status"
}

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { onMounted, ref, computed, watch } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import {
  MessageTemplate,
  PhoneNumber,
  WhatsappTemplate,
  CreateableTemplateComponent,
  CreateableHeaderComponent,
  CreateableBodyComponent,
  CreateableFooterComponent,
  CreateableButtonsComponent,
  ButtonTypeURL,
  HeaderComponent,
  WhatsappHeaderComponent,
  isWhatsappHeaderComponent,
  TextHeaderParameter,
  isLocationHeaderParameter,
  isVideoHeaderParameter,
  isDocumentHeaderParameter,
  isImageHeaderParameter,
  isTextHeaderParameter
} from '../services/AccountService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import AccountService from '@/services/AccountService/AccountService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AEmptyViewCard, AIcon, AInput, ASelector, ATag } from '@adereso-ai/vue-components'
import { normalizeSearchTerm } from '@/utils/search'
import type { ProductCatalog } from '@/services/MetaService/types'
import { catalogSendComponent, catalogTemplateError, createCatalogComponents, isCatalogTemplate } from '@/utils/catalogTemplates'
import { useCatalogVisibility } from '@/composables/useCatalogVisibility'
import { useCatalogThumbnail } from '@/composables/useCatalogThumbnail'
import { catalogImageUrl, catalogPreviewLabels, interpolateTemplateText } from '@/utils/catalogPreview'


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageTemplatesView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')
const phoneNumber = ref<PhoneNumber | undefined>(undefined)

const testPhoneNumber = ref('')
const messageTemplateName = ref('')
const messageTemplateLanguage = ref('')
const messageTemplateCategory = ref('')
const messageTemplateType = ref('standard')
const creatingTemplate = ref(false)
const sendingTest = ref(false)
const productCatalogs = ref<ProductCatalog[]>([])
const catalogsLoading = ref(true)
const catalogsError = ref('')
const selectedTestTemplate = ref<MessageTemplate>()
const testCatalogThumbnailSku = ref('')

const templateTypeOptions = [
  { title: 'Standard', value: 'standard' },
  { title: 'Catalog', value: 'catalog' }
]
const isCreatingCatalogTemplate = computed(() => messageTemplateType.value === 'catalog')
const isTestingCatalogTemplate = computed(() => Boolean(selectedTestTemplate.value && isCatalogTemplate(selectedTestTemplate.value)))
const associatedCatalog = computed(() => productCatalogs.value.find(catalog => catalog.is_associated))
const {
  product: thumbnailProduct, products: thumbnailProducts, nextCursor: thumbnailNextCursor,
  loading: thumbnailLoading, loadingMore: thumbnailLoadingMore, error: thumbnailError,
  loadMoreError: thumbnailLoadMoreError, refresh: refreshThumbnail, loadMore: loadMoreThumbnailProducts
} = useCatalogThumbnail(
  computed(() => currentUser.value && isTestingCatalogTemplate.value ? String(route.params.wabaId || '') : ''),
  computed(() => isTestingCatalogTemplate.value ? associatedCatalog.value?.id || '' : ''),
  testCatalogThumbnailSku, MetaService.getInstance
)
const thumbnailProductOptions = computed(() => thumbnailProducts.value.map(product => ({
  title: `${product.name || 'Unnamed product'} · SKU ${product.retailer_id}`, value: product.retailer_id
})))
const selectedThumbnailSku = computed({
  get: () => testCatalogThumbnailSku.value || thumbnailProduct.value?.retailer_id || '',
  set: (value: string | null) => { testCatalogThumbnailSku.value = value || '' }
})
const catalogImageFailed = ref(false)
const catalogThumbnailImageUrl = computed(() => catalogImageUrl(thumbnailProduct.value?.image_url))
watch(catalogThumbnailImageUrl, () => { catalogImageFailed.value = false })
const catalogCardLabels = computed(() => catalogPreviewLabels(selectedTestTemplate.value?.language || 'en', phoneNumber.value?.verified_name || ''))
const catalogReady = computed(() => !catalogsLoading.value && !catalogsError.value && Boolean(associatedCatalog.value) && associatedCatalog.value?.product_count !== 0)
const canSendTest = computed(() => {
  if (sendingTest.value || !testingMessageTemplate.value || !testPhoneNumber.value.trim()) return false
  if (!isTestingCatalogTemplate.value) return true
  return catalogReady.value && Boolean(thumbnailProduct.value?.retailer_id) && !thumbnailLoading.value && !thumbnailError.value &&
    catalogVisible.value === true && !visibilityLoading.value && !visibilitySaving.value &&
    selectedTestTemplate.value?.status === 'APPROVED' &&
    /^\d{7,15}$/.test(testPhoneNumber.value.trim()) &&
    testingMessageTemplate.value.components.every(component => component.type !== 'body' ||
      component.parameters?.every(parameter => 'text' in parameter && Boolean(parameter.text?.trim())))
})

const languageOptions = [
  { title: 'Spanish', value: 'es' },
  { title: 'English', value: 'en' },
  { title: 'French', value: 'fr' }
]

const categoryOptions = [
  { title: 'Authentication', value: 'AUTHENTICATION' },
  { title: 'Marketing', value: 'MARKETING' },
  { title: 'Utility', value: 'UTILITY' }
]

const headerFormatOptions = [
  { title: 'Text', value: 'TEXT' },
  { title: 'Image', value: 'IMAGE' },
  { title: 'Video', value: 'VIDEO' },
  { title: 'Document', value: 'DOCUMENT' },
  { title: 'Location', value: 'LOCATION' }
]

const messageTemplates = ref<Array<MessageTemplate>>([])
const hasCatalogTemplates = computed(() => messageTemplates.value.some(isCatalogTemplate))
const needsCatalogVisibility = computed(() => isCreatingCatalogTemplate.value || isTestingCatalogTemplate.value || hasCatalogTemplates.value)
const {
  visible: catalogVisible, loading: visibilityLoading, saving: visibilitySaving,
  error: visibilityError, refresh: refreshVisibility
} = useCatalogVisibility(
  computed(() => currentUser.value && needsCatalogVisibility.value ? String(route.params.wabaId || '') : ''),
  computed(() => currentUser.value && needsCatalogVisibility.value ? String(route.params.phoneNumberId || '') : ''),
  MetaService.getInstance
)

const templateSearch = ref('')

const testingMessageTemplate = ref<WhatsappTemplate | undefined>(undefined)

const headerComponent = ref<CreateableHeaderComponent | undefined>(undefined)

const bodyComponent = ref<CreateableBodyComponent | undefined>(undefined)

const footerComponent = ref<CreateableFooterComponent | undefined>(undefined)

const buttonsComponent = ref<CreateableButtonsComponent | undefined>(undefined)

const templateBreadcrumbs = computed(() => [
  { title: 'Accounts', to: { name: 'whatsapp-business-accounts' } },
  {
    title: 'Phone number',
    to: {
      name: 'phone-number',
      params: { wabaId: String(route.params.wabaId), phoneNumberId: String(route.params.phoneNumberId) }
    }
  },
  { title: 'Templates', disabled: true }
])

const filteredMessageTemplates = computed(() => {
  const query = normalizeSearchTerm(templateSearch.value)
  if (!query) return messageTemplates.value

  return messageTemplates.value.filter((messageTemplate) =>
    [messageTemplate.name, messageTemplate.language, messageTemplate.status]
      .some((value) => String(value || '').toLowerCase().includes(query))
  )
})

const testTemplateParameterCount = computed(() => {
  return testingMessageTemplate.value?.components.reduce((total, component) => {
    return total + (component.parameters?.length || 0)
  }, 0) || 0
})

const existingComponents = computed(() => {
  if (isCreatingCatalogTemplate.value && bodyComponent.value) {
    return createCatalogComponents(bodyComponent.value, footerComponent.value)
  }
  const components: CreateableTemplateComponent[] = []

  if (headerComponent.value !== undefined) {
    components.push(headerComponent.value)
  }
  if (bodyComponent.value !== undefined) {
    components.push(bodyComponent.value)
  }
  if (footerComponent.value !== undefined) {
    components.push(footerComponent.value)
  }
  if (buttonsComponent.value !== undefined) {
    components.push(buttonsComponent.value)
  }

  return components
})

const catalogCreationError = computed(() => {
  if (!isCreatingCatalogTemplate.value) return undefined
  if (!catalogReady.value) return 'A connected catalog with products is required.'
  return catalogTemplateError({
    name: messageTemplateName.value,
    language: messageTemplateLanguage.value,
    category: messageTemplateCategory.value,
    components: existingComponents.value
  })
})

function onTemplateTypeChange () {
  if (isCreatingCatalogTemplate.value) {
    messageTemplateCategory.value = 'MARKETING'
    headerComponent.value = undefined
    if (!bodyComponent.value) addBodyComponent()
    buttonsComponent.value = { type: 'BUTTONS', buttons: [{ type: 'CATALOG', text: 'View catalog' }] }
  } else if (buttonsComponent.value?.buttons.some(button => button.type === 'CATALOG')) {
    buttonsComponent.value = undefined
  }
}

function numberOfParameters (text: string) {
  const regex = /\{\{(\d+)\}\}/g
  const matches = text.match(regex)
  const numberOfParameters = matches ? new Set(matches).size : 0
  return numberOfParameters
}

function onUrlButtonUrlInput (button: ButtonTypeURL) {
  const numberOfParams = numberOfParameters(button.url)
  if (numberOfParams) {
    button.example = []
    for (let i = 0; i < numberOfParams; i++) {
      button.example.push('')
    }
  } else {
    button.example = null
  }
}

function onBodyTextInput (bodyComponent: CreateableBodyComponent) {
  const numberOfParams = numberOfParameters(bodyComponent.text)
  if (numberOfParams) {
    bodyComponent.example = { body_text: [[]] }
    for (let i = 0; i < numberOfParams; i++) {
      bodyComponent.example.body_text[0].push('')
    }
  } else {
    bodyComponent.example = null
  }
}

function onHeaderTextInput (headerComponent: CreateableHeaderComponent) {
  if (headerComponent.text) {
    const numberOfParams = numberOfParameters(headerComponent.text)
    if (numberOfParams) {
      headerComponent.example = { header_text: [] }
      for (let i = 0; i < numberOfParams; i++) {
        headerComponent.example.header_text.push('')
      }
    } else {
      headerComponent.example = null
    }
  }
}

function selectTestTemplate (messageTemplate: MessageTemplate) {
  selectedTestTemplate.value = messageTemplate
  testCatalogThumbnailSku.value = ''
  testingMessageTemplate.value = {
    name: messageTemplate.name,
    language: { code: messageTemplate.language },
    components: []
  }

  let buttonCounter = 0
  let numberOfParams = 0
  let parameters = []

  for (const component of messageTemplate.components) {
    switch (component.type) {
      case 'HEADER': {
        const header = component as HeaderComponent
        const testHeader = {
          type: 'header',
          text: header.text,
          format: header.format,
          parameters: []
        } as WhatsappHeaderComponent
        const headerParameters: any[] = []
        switch (header.format) {
          case 'TEXT':
            numberOfParams = numberOfParameters(header.text)
            for (let i = 0; i < numberOfParams; i++) {
              headerParameters.push({ type: 'text', text: '', id: i })
            }
            break
          case 'IMAGE':
            headerParameters.push({
              type: 'image',
              image: {
                link: header.example?.header_handle[0] || '',
                default: header.example?.header_handle[0] || ''
              }
            })
            break
          case 'VIDEO':
            headerParameters.push({
              type: 'video',
              video: {
                link: header.example?.header_handle[0] || '',
                default: header.example?.header_handle[0] || ''
              }
            })
            break
          case 'DOCUMENT':
            headerParameters.push({
              type: 'document',
              document: {
                link: header.example?.header_handle[0] || '',
                filename: '',
                default: header.example?.header_handle[0] || ''
              }
            })
            break
          case 'LOCATION':
            headerParameters.push({
              type: 'location',
              location: {
                latitude: '',
                longitude: '',
                name: '',
                address: ''
              }
            })
            break
        }
        testHeader.parameters = headerParameters
        testingMessageTemplate.value.components.push(testHeader)
        break
      }
      case 'BODY':
        numberOfParams = numberOfParameters(component.text)
        parameters = []
        for (let i = 0; i < numberOfParams; i++) {
          parameters.push({ type: 'text', text: '', id: i })
        }
        testingMessageTemplate.value.components.push({
          type: component.type.toLowerCase(),
          text: component.text,
          parameters
        })
        break
      case 'FOOTER':
        testingMessageTemplate.value.components.push({
          type: 'footer',
          text: component.text
        })
        break
      case 'BUTTONS':
        for (const button of component.buttons) {
          switch (button.type) {
            case 'CATALOG':
              testingMessageTemplate.value.components.push({ ...catalogSendComponent(buttonCounter.toString()), text: button.text })
              break
            case 'QUICK_REPLY':
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'quick_reply',
                text: button.text,
                index: buttonCounter.toString(),
                parameters: [{ type: 'payload', payload: button.text }]
              })
              break
            case 'PHONE_NUMBER':
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'phone_number',
                text: button.text,
                index: buttonCounter.toString(),
                parameters: [{ type: 'phone_number', text: button.text }]
              })
              break
            case 'URL':
              numberOfParams = 0
              numberOfParams = numberOfParameters(button.url)
              parameters = []
              for (let i = 0; i < numberOfParams; i++) {
                parameters.push({ type: 'text', text: '', index: i })
              }
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'url',
                url: button.url,
                index: buttonCounter.toString(),
                parameters
              })
              break
            case 'COPY_CODE':
              testingMessageTemplate.value.components.push({
                type: 'button',
                sub_type: 'copy_code',
                text: button.text,
                index: buttonCounter.toString(),
                parameters: [
                  {
                    type: 'coupon_code',
                    coupon_code: button.example[0]
                  }
                ]
              })
              break
          }
          buttonCounter++
        }
        break
    }
  }
}

const failedToLoadImage = ref(false)

function addBodyComponent () {
  bodyComponent.value = { type: 'BODY', text: '' }
}

function addHeaderComponent () {
  headerComponent.value = { type: 'HEADER', text: '', format: 'TEXT' }
}

function addFooterComponent () {
  footerComponent.value = { type: 'FOOTER', text: '' }
}

function addButtonsComponent () {
  buttonsComponent.value = { type: 'BUTTONS', buttons: [] }
}

function removeHeaderComponent () {
  headerComponent.value = undefined
}

function removeBodyComponent () {
  if (isCreatingCatalogTemplate.value) return
  bodyComponent.value = undefined
}

function removeFooterComponent () {
  footerComponent.value = undefined
}

function removeButtonsComponent () {
  if (isCreatingCatalogTemplate.value) return
  buttonsComponent.value = undefined
}

function removeTemplateButton (buttonIndex: number) {
  buttonsComponent.value?.buttons.splice(buttonIndex, 1)
}

function buttonTypeLabel (buttonType: string) {
  const labels: Record<string, string> = {
    QUICK_REPLY: 'Quick reply',
    PHONE_NUMBER: 'Phone number',
    URL: 'Link',
    COPY_CODE: 'Copy code'
  }
  return labels[buttonType] || buttonType
}

function addQuickReplyButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ text: '', type: 'QUICK_REPLY' })
}

function addPhoneNumberButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ phone_number: '', text: '', type: 'PHONE_NUMBER' })
}

function addUrlrButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ url: '', text: '', example: [], type: 'URL' })
}

function addCopyCodeButton (buttonsComponent: CreateableButtonsComponent) {
  buttonsComponent.buttons.push({ example: [''], type: 'COPY_CODE', text: 'Copy offer code' })
}

function validTemplate () {
  if (isCreatingCatalogTemplate.value) return catalogCreationError.value === undefined
  return messageTemplateName.value !== '' && messageTemplateLanguage.value !== '' && existingComponents.value.length > 0 && bodyComponent.value !== undefined
}

async function createMessageTemplate () {
  if (creatingTemplate.value) return
  if (!validTemplate()) {
    toastError(catalogCreationError.value || 'All fields are required')
    return
  }
  creatingTemplate.value = true
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string

  const messageTemplateCreation = {
    name: messageTemplateName.value,
    language: messageTemplateLanguage.value,
    category: messageTemplateCategory.value,
    components: existingComponents.value
  }

  try {
    const accountService = await AccountService.getInstance()
    await accountService.createMessageTemplate(wabaId, phoneNumberId, messageTemplateCreation)
    toastSuccess('Message template created')
    await getMessageTemplates(wabaId, phoneNumberId)
  } catch (error) {
    toastError('Error creating message template: ' + error)
  } finally {
    creatingTemplate.value = false
  }
}

async function deleteMessageTemplate (messageTemplate: MessageTemplate) {
  loading.value = true
  const metaService = await MetaService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  try {
    await metaService.deleteMessageTemplate(wabaId, phoneNumberId, messageTemplate.id, messageTemplate.name)
    toastSuccess('Message template deleted')
    await getMessageTemplates(wabaId, phoneNumberId)
  } catch (error) {
    toastError('Error deleting message template:' + error)
  }
  loading.value = false
}

async function testMessageTemplate () {
  if (sendingTest.value) return
  if (testingMessageTemplate.value === undefined) {
    toastError('Message template is needed to send template')
    return
  }
  if (testPhoneNumber.value === '') {
    toastError('Test phone number is needed to send template')
    return
  }
  if (!canSendTest.value) {
    toastError(isTestingCatalogTemplate.value && catalogVisible.value !== true
      ? 'Confirm that the catalog is visible for this WhatsApp number before sending.'
      : 'Use an approved template, a connected catalog with products, and complete the recipient and body variables.')
    return
  }
  sendingTest.value = true
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  const components = testingMessageTemplate.value.components.filter((component) => {
    return component.type !== 'footer' &&
      (component.type !== 'button' ||
      (component.sub_type !== 'phone_number'))
  }).map(component => component.type === 'button' && component.sub_type === 'CATALOG'
    ? catalogSendComponent(component.index, thumbnailProduct.value?.retailer_id || '')
    : component)
  const testTemplate = { ...testingMessageTemplate.value, components }

  try {
    const metaService = await MetaService.getInstance()
    const response = await metaService.testMessageTemplate(
      wabaId, phoneNumberId, testPhoneNumber.value.trim(), testTemplate
    )
    const message = response.messages[0]
    toastSuccess(`Sent message to ${testPhoneNumber.value}. Message ID: ${message.id} (status: ${message.message_status})`)
  } catch (error) {
    toastError('Error testing message template: ' + String(error))
  } finally {
    sendingTest.value = false
  }
}

async function refreshCatalogReadiness () {
  await Promise.allSettled([getProductCatalogs(), refreshVisibility()])
  await refreshThumbnail()
}

async function getProductCatalogs () {
  if (!route.params.wabaId) return
  catalogsLoading.value = true
  catalogsError.value = ''
  try {
    const metaService = await MetaService.getInstance()
    productCatalogs.value = await metaService.getProductCatalogs(String(route.params.wabaId))
  } catch (error) {
    catalogsError.value = `Unable to check the connected catalog: ${error instanceof Error ? error.message : String(error)}`
  } finally {
    catalogsLoading.value = false
  }
}

async function synchronizeMessageTemplates () {
  loading.value = true
  const metaService = await MetaService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  try {
    await metaService.synchronizeMessageTemplates(wabaId, phoneNumberId)
    toastSuccess('Message templates synchronized')
    await getMessageTemplates(wabaId, phoneNumberId)
    await getProductCatalogs()
  } catch (error) {
    toastError('Error synchronizing message templates')
  }
  loading.value = false
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

async function getphoneNumber (wabaId: string, phoneNumberId: string) {
  try {
    const accountService = await AccountService.getInstance()
    phoneNumber.value = await accountService.getphoneNumber(wabaId, phoneNumberId)
  } catch {
    toastError('Error getting phone number')
  }
}

async function getMessageTemplates (wabaId: string, phoneNumberId: string) {
  try {
    const accountService = await AccountService.getInstance()
    messageTemplates.value = await accountService.getMessageTemplates(wabaId, phoneNumberId)
    if (selectedTestTemplate.value) {
      selectedTestTemplate.value = messageTemplates.value.find(template => template.id === selectedTestTemplate.value?.id)
      if (!selectedTestTemplate.value) testingMessageTemplate.value = undefined
    }
  } catch {
    toastError('Error getting message templates')
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string

  if (phoneNumberId && wabaId) {
    await getphoneNumber(wabaId, phoneNumberId)
    await getMessageTemplates(wabaId, phoneNumberId)
    await getProductCatalogs()
  } else {
    router.push({ name: 'home' })
  }

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

function toastSuccess (successMessage: string) {
  try {
    toast.success(String(successMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && phoneNumber.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BspPageHeader, {
            eyebrow: "Phone number settings",
            title: "Message templates",
            description: "View, test, and manage the templates available for this phone number.",
            icon: "tabler:message-code",
            breadcrumbs: templateBreadcrumbs.value
          }, {
            actions: _withCtx(() => [
              _createVNode(_unref(AButton), {
                color: "blue",
                variant: "outlined",
                "prepend-icon": "tabler:refresh",
                onClick: synchronizeMessageTemplates
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode(" Synchronize ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["breadcrumbs"]),
          (isCreatingCatalogTemplate.value || isTestingCatalogTemplate.value || hasCatalogTemplates.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[23] || (_cache[23] = _createElementVNode("h2", null, "Connected product catalog", -1)),
                  (catalogsLoading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Checking the WABA catalog…"))
                    : (catalogsError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(catalogsError.value), 1))
                      : (associatedCatalog.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                            _createTextVNode(_toDisplayString(associatedCatalog.value.name) + " · " + _toDisplayString(associatedCatalog.value.product_count ?? 'Unknown number of') + " products. ", 1),
                            (associatedCatalog.value.product_count === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Add products in Meta Commerce Manager before creating or sending a catalog template."))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, "The template opens this WABA's catalog. Products must be approved by Meta."))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_9, "Connect a catalog with products to this WABA before creating or sending a catalog template.")),
                  (_unref(visibilityLoading) || _unref(visibilitySaving))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Checking catalog visibility for this WhatsApp number…"))
                    : (_unref(visibilityError))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Catalog visibility could not be confirmed. Refresh visibility before sending a catalog template. " + _toDisplayString(_unref(visibilityError)), 1))
                      : (_unref(catalogVisible) === false)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "The catalog is hidden for this WhatsApp number. Catalog templates cannot be sent until you enable visibility in Manage catalogs."))
                        : (_unref(catalogVisible) === true)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, "The catalog is visible for this WhatsApp number. Meta must also approve the template and its products."))
                          : (_openBlock(), _createElementBlock("p", _hoisted_14, "Catalog visibility has not been confirmed for this WhatsApp number."))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(AButton), {
                    size: "small",
                    variant: "outlined",
                    loading: catalogsLoading.value || _unref(visibilityLoading),
                    disabled: _unref(visibilitySaving),
                    onClick: refreshCatalogReadiness
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createTextVNode("Refresh catalog and visibility", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  _createVNode(_unref(AButton), {
                    size: "small",
                    variant: "text",
                    "prepend-icon": "tabler:shopping-bag",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'product-catalogs', params: { wabaId: String(_unref(route).params.wabaId) }, query: { phoneNumberId: String(_unref(route).params.phoneNumberId) } })))
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("Manage catalogs", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", null, [
                      _createElementVNode("h2", null, "Available templates"),
                      _createElementVNode("p", null, "Select a template to prepare a test message.")
                    ], -1)),
                    _createVNode(_unref(ATag), {
                      text: `${filteredMessageTemplates.value.length} ${filteredMessageTemplates.value.length === 1 ? 'template' : 'templates'}`,
                      color: "primary",
                      type: "secondary",
                      pill: ""
                    }, null, 8, ["text"])
                  ]),
                  _createVNode(_unref(AInput), {
                    modelValue: templateSearch.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((templateSearch).value = $event)),
                    class: "bsp-search-input",
                    label: "Search templates",
                    placeholder: "Name, language, or status",
                    "prepend-inner-icon": "tabler:search",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  (filteredMessageTemplates.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMessageTemplates.value, (messageTemplate) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["message-template", { 'selected': testingMessageTemplate.value && messageTemplate.name == testingMessageTemplate.value.name }]),
                            onClick: ($event: any) => (selectTestTemplate(messageTemplate)),
                            key: messageTemplate.id
                          }, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(messageTemplate.name), 1),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_unref(ATag), {
                                text: messageTemplate.language,
                                color: "info",
                                type: "secondary",
                                pill: ""
                              }, null, 8, ["text"]),
                              _createVNode(_unref(ATag), {
                                text: messageTemplate.status,
                                color: messageTemplate.status === 'APPROVED' ? 'success' : messageTemplate.status === 'REJECTED' ? 'error' : 'warning',
                                type: "secondary",
                                pill: ""
                              }, null, 8, ["text", "color"]),
                              (_unref(isCatalogTemplate)(messageTemplate) && _unref(catalogVisible) === false)
                                ? (_openBlock(), _createBlock(_unref(ATag), {
                                    key: 0,
                                    text: "Catalog hidden for this number",
                                    color: "warning",
                                    type: "secondary",
                                    pill: ""
                                  }))
                                : _createCommentVNode("", true),
                              (messageTemplate.rejected_reason !== 'NONE')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(messageTemplate.rejected_reason || ''), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_unref(AButton), {
                                color: "red",
                                variant: "text",
                                size: "small",
                                "prepend-icon": "tabler:trash",
                                onClick: _withModifiers(($event: any) => (deleteMessageTemplate(messageTemplate)), ["stop"])
                              }, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createTextVNode(" Delete ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ], 10, _hoisted_22))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                        key: 1,
                        title: "No templates found",
                        description: templateSearch.value ? 'Try another search.' : 'Synchronize with Meta to load the available templates.',
                        icon: "tabler:message-off"
                      }, null, 8, ["description"]))
                ]),
                (testingMessageTemplate.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[28] || (_cache[28] = _createElementVNode("div", null, [
                          _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Controlled message"),
                          _createElementVNode("h3", { id: "template-test-title" }, "Test template"),
                          _createElementVNode("p", null, "Complete the variables and review the message before sending it.")
                        ], -1)),
                        _createVNode(_unref(ATag), {
                          text: testingMessageTemplate.value.name,
                          color: "primary",
                          type: "secondary",
                          "prepend-icon": "tabler:message-code",
                          "limited-width": 240,
                          pill: ""
                        }, null, 8, ["text"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_unref(AIcon), {
                              icon: "tabler:message-circle",
                              color: "primary",
                              size: "18"
                            }),
                            _cache[29] || (_cache[29] = _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Message preview"),
                              _createElementVNode("p", null, "This is how the main content will appear in WhatsApp.")
                            ], -1))
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:brand-whatsapp",
                                color: "success",
                                size: "16"
                              }),
                              _cache[30] || (_cache[30] = _createElementVNode("span", null, "Template message", -1))
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              (isTestingCatalogTemplate.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_35, [
                                      (catalogThumbnailImageUrl.value && !catalogImageFailed.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: catalogThumbnailImageUrl.value,
                                            alt: _unref(thumbnailProduct)?.name || 'Catalog product thumbnail',
                                            referrerpolicy: "no-referrer",
                                            onError: _cache[2] || (_cache[2] = ($event: any) => (catalogImageFailed.value = true))
                                          }, null, 40, _hoisted_36))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _createVNode(_unref(AIcon), {
                                              icon: "tabler:shopping-bag",
                                              color: "primary",
                                              size: "22"
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(_unref(thumbnailLoading) ? 'Loading product image…' : _unref(thumbnailError) || (catalogImageFailed.value ? 'Image unavailable in this browser' : 'No usable product image returned')), 1)
                                          ]))
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("strong", null, _toDisplayString(catalogCardLabels.value.title), 1),
                                      _createElementVNode("p", null, _toDisplayString(catalogCardLabels.value.subtitle), 1)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testingMessageTemplate.value.components, (component, componentIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: componentIndex,
                                  class: "bsp-template-preview__component"
                                }, [
                                  (_unref(isWhatsappHeaderComponent)(component))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        (component.parameters?.length && _unref(isImageHeaderParameter)(component.parameters[0]))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _withDirectives(_createElementVNode("img", {
                                                src: component.parameters[0].image.link,
                                                onError: _cache[3] || (_cache[3] = ($event: any) => (failedToLoadImage.value = true)),
                                                onLoad: _cache[4] || (_cache[4] = ($event: any) => (failedToLoadImage.value = false)),
                                                alt: "Header preview"
                                              }, null, 40, _hoisted_40), [
                                                [_vShow, !failedToLoadImage.value]
                                              ]),
                                              _withDirectives(_createElementVNode("div", _hoisted_41, [
                                                _createVNode(_unref(AIcon), {
                                                  icon: "tabler:photo-off",
                                                  color: "info",
                                                  size: "22"
                                                }),
                                                _cache[31] || (_cache[31] = _createElementVNode("span", null, "Unable to load the image", -1))
                                              ], 512), [
                                                [_vShow, failedToLoadImage.value]
                                              ])
                                            ], 64))
                                          : (component.format && component.format !== 'TEXT')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                _createVNode(_unref(AIcon), {
                                                  icon: "tabler:paperclip",
                                                  color: "info",
                                                  size: "22"
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(component.format.toLowerCase()) + " header", 1)
                                              ]))
                                            : (component.text)
                                              ? (_openBlock(), _createElementBlock("strong", _hoisted_43, _toDisplayString(_unref(interpolateTemplateText)(component.text, component.parameters)), 1))
                                              : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (component.type === 'body')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_unref(interpolateTemplateText)(component.text, component.parameters)), 1))
                                    : _createCommentVNode("", true),
                                  (component.type === 'footer')
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_45, _toDisplayString(component.text), 1))
                                    : _createCommentVNode("", true),
                                  (component.type === 'button')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _createVNode(_unref(AIcon), {
                                          icon: component.sub_type === 'CATALOG' ? 'tabler:shopping-bag' : component.sub_type === 'phone_number' ? 'tabler:phone' : component.sub_type === 'url' ? 'tabler:external-link' : component.sub_type === 'copy_code' ? 'tabler:copy' : 'tabler:corner-up-left',
                                          color: "primary",
                                          size: "15"
                                        }, null, 8, ["icon"]),
                                        _createElementVNode("span", null, _toDisplayString(component.sub_type === 'CATALOG' ? catalogCardLabels.value.button : component.text || (component.sub_type === 'phone_number' ? 'Call' : component.sub_type === 'url' ? 'Open link' : component.sub_type === 'copy_code' ? 'Copy code' : 'Reply')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]),
                          (isTestingCatalogTemplate.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _cache[34] || (_cache[34] = _createElementVNode("h5", null, "Catalog thumbnail", -1)),
                                _createVNode(_unref(ASelector), {
                                  modelValue: selectedThumbnailSku.value,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedThumbnailSku).value = $event)),
                                  size: "small",
                                  label: "Thumbnail product",
                                  items: thumbnailProductOptions.value,
                                  "item-title": "title",
                                  "item-value": "value",
                                  autocomplete: "",
                                  placeholder: "Search by product name or SKU",
                                  "no-data-text": "No matching products",
                                  loading: _unref(thumbnailLoading),
                                  disabled: sendingTest.value || _unref(thumbnailLoading) || !thumbnailProductOptions.value.length
                                }, null, 8, ["modelValue", "items", "loading", "disabled"]),
                                _cache[35] || (_cache[35] = _createElementVNode("p", { class: "bsp-template-field-caption" }, "Choose a product from the connected catalog. The test message will use the same product shown in this preview.", -1)),
                                (_unref(thumbnailNextCursor))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, "More products are available. Load more to include them in your search."))
                                  : _createCommentVNode("", true),
                                (_unref(thumbnailProduct))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_49, "Preview product: " + _toDisplayString(_unref(thumbnailProduct).name || _unref(thumbnailProduct).retailer_id) + " · SKU " + _toDisplayString(_unref(thumbnailProduct).retailer_id), 1))
                                  : _createCommentVNode("", true),
                                (_unref(thumbnailError))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_unref(thumbnailError)), 1))
                                  : _createCommentVNode("", true),
                                (_unref(thumbnailLoadMoreError))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_unref(thumbnailLoadMoreError)), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_52, [
                                  (_unref(thumbnailNextCursor))
                                    ? (_openBlock(), _createBlock(_unref(AButton), {
                                        key: 0,
                                        variant: "outlined",
                                        size: "small",
                                        loading: _unref(thumbnailLoadingMore),
                                        disabled: sendingTest.value || _unref(thumbnailLoading) || _unref(thumbnailLoadingMore),
                                        onClick: _unref(loadMoreThumbnailProducts)
                                      }, {
                                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                          _createTextVNode("Load more products", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["loading", "disabled", "onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_unref(AButton), {
                                    variant: "text",
                                    size: "small",
                                    disabled: sendingTest.value || _unref(thumbnailLoading) || _unref(thumbnailLoadingMore),
                                    onClick: _unref(refreshThumbnail)
                                  }, {
                                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                      _createTextVNode("Refresh products", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled", "onClick"])
                                ]),
                                _cache[36] || (_cache[36] = _createElementVNode("p", { class: "bsp-template-field-caption" }, "WhatsApp controls the final rendering and translations.", -1)),
                                (selectedTestTemplate.value?.status !== 'APPROVED')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_53, "Meta must approve this catalog template before it can be sent."))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_unref(AIcon), {
                              icon: "tabler:braces",
                              color: "primary",
                              size: "18"
                            }),
                            _cache[37] || (_cache[37] = _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Message variables"),
                              _createElementVNode("p", null, "The values you enter replace the template placeholders.")
                            ], -1))
                          ]),
                          (testTemplateParameterCount.value === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createVNode(_unref(AIcon), {
                                  icon: "tabler:circle-check",
                                  color: "success",
                                  size: "18"
                                }),
                                _cache[38] || (_cache[38] = _createTextVNode(" This template doesn't require variables. ", -1))
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testingMessageTemplate.value.components, (component, componentIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `parameters-${componentIndex}`,
                              class: "bsp-template-variable-component"
                            }, [
                              (_unref(isWhatsappHeaderComponent)(component) && component.parameters?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _cache[42] || (_cache[42] = _createElementVNode("h5", null, "Header", -1)),
                                    (_unref(isTextHeaderParameter)(component.parameters[0]))
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((component.parameters as TextHeaderParameter[]), (parameter, parameterIndex) => {
                                          return (_openBlock(), _createBlock(_unref(AInput), {
                                            key: parameter.id || parameterIndex,
                                            modelValue: parameter.text,
                                            "onUpdate:modelValue": ($event: any) => ((parameter.text) = $event),
                                            size: "small",
                                            label: `Variable {{${parameterIndex + 1}}}`,
                                            placeholder: "Enter a value"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                        }), 128))
                                      : (_unref(isImageHeaderParameter)(component.parameters[0]))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                            _createVNode(_unref(AInput), {
                                              modelValue: component.parameters[0].image.link,
                                              "onUpdate:modelValue": ($event: any) => ((component.parameters[0].image.link) = $event),
                                              size: "small",
                                              label: "Image URL",
                                              placeholder: "https://..."
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                            _createVNode(_unref(AButton), {
                                              variant: "text",
                                              size: "small",
                                              "prepend-icon": "tabler:restore",
                                              onClick: ($event: any) => (component.parameters[0].image.link = component.parameters[0].image.default || '')
                                            }, {
                                              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                                _createTextVNode(" Restore original URL ", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]))
                                        : (_unref(isVideoHeaderParameter)(component.parameters[0]))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                              _createVNode(_unref(AInput), {
                                                modelValue: component.parameters[0].video.link,
                                                "onUpdate:modelValue": ($event: any) => ((component.parameters[0].video.link) = $event),
                                                size: "small",
                                                label: "Video URL",
                                                placeholder: "https://..."
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                              _createVNode(_unref(AButton), {
                                                variant: "text",
                                                size: "small",
                                                "prepend-icon": "tabler:restore",
                                                onClick: ($event: any) => (component.parameters[0].video.link = component.parameters[0].video.default || '')
                                              }, {
                                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                  _createTextVNode(" Restore original URL ", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["onClick"])
                                            ]))
                                          : (_unref(isDocumentHeaderParameter)(component.parameters[0]))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                _createVNode(_unref(AInput), {
                                                  modelValue: component.parameters[0].document.link,
                                                  "onUpdate:modelValue": ($event: any) => ((component.parameters[0].document.link) = $event),
                                                  size: "small",
                                                  label: "Document URL",
                                                  placeholder: "https://..."
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_unref(AInput), {
                                                  modelValue: component.parameters[0].document.filename,
                                                  "onUpdate:modelValue": ($event: any) => ((component.parameters[0].document.filename) = $event),
                                                  size: "small",
                                                  label: "File name",
                                                  placeholder: "document.pdf"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                _createVNode(_unref(AButton), {
                                                  variant: "text",
                                                  size: "small",
                                                  "prepend-icon": "tabler:restore",
                                                  onClick: ($event: any) => (component.parameters[0].document.link = component.parameters[0].document.default || '')
                                                }, {
                                                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                                    _createTextVNode(" Restore original URL ", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 8, ["onClick"])
                                              ]))
                                            : (_unref(isLocationHeaderParameter)(component.parameters[0]))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.latitude,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.latitude) = $event),
                                                    size: "small",
                                                    label: "Latitude"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.longitude,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.longitude) = $event),
                                                    size: "small",
                                                    label: "Longitude"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.name,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.name) = $event),
                                                    size: "small",
                                                    label: "Name"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createVNode(_unref(AInput), {
                                                    modelValue: component.parameters[0].location.address,
                                                    "onUpdate:modelValue": ($event: any) => ((component.parameters[0].location.address) = $event),
                                                    size: "small",
                                                    label: "Address"
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]))
                                              : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (component.type === 'body' && component.parameters?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _cache[43] || (_cache[43] = _createElementVNode("h5", null, "Message body", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.parameters, (parameter, parameterIndex) => {
                                      return (_openBlock(), _createBlock(_unref(AInput), {
                                        key: parameterIndex,
                                        modelValue: parameter.text,
                                        "onUpdate:modelValue": ($event: any) => ((parameter.text) = $event),
                                        size: "small",
                                        label: `Variable {{${parameterIndex + 1}}}`,
                                        placeholder: "Enter a value"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (component.type === 'button' && component.parameters?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _cache[44] || (_cache[44] = _createElementVNode("h5", null, "Button action", -1)),
                                    (component.sub_type === 'quick_reply')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 0,
                                          modelValue: component.parameters[0].payload,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].payload) = $event),
                                          size: "small",
                                          label: "Reply payload",
                                          placeholder: "Payload"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (component.sub_type === 'phone_number')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 1,
                                          modelValue: component.parameters[0].text,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].text) = $event),
                                          size: "small",
                                          label: "Phone number",
                                          placeholder: "569..."
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (component.sub_type === 'url')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 2,
                                          modelValue: component.parameters[0].text,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].text) = $event),
                                          size: "small",
                                          label: "URL suffix",
                                          placeholder: "value"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (component.sub_type === 'copy_code')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 3,
                                          modelValue: component.parameters[0].coupon_code,
                                          "onUpdate:modelValue": ($event: any) => ((component.parameters[0].coupon_code) = $event),
                                          size: "small",
                                          label: "Code",
                                          placeholder: "Code"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", _hoisted_65, [
                          _createVNode(_unref(AIcon), {
                            icon: "tabler:device-mobile-message",
                            color: "primary",
                            size: "22"
                          })
                        ]),
                        _cache[46] || (_cache[46] = _createElementVNode("div", { class: "bsp-template-recipient__copy" }, [
                          _createElementVNode("h4", null, "Recipient phone number"),
                          _createElementVNode("p", null, "Use international format without spaces or the “+” symbol.")
                        ], -1)),
                        _createVNode(_unref(AInput), {
                          modelValue: testPhoneNumber.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((testPhoneNumber).value = $event)),
                          class: "bsp-template-recipient__input",
                          type: "tel",
                          size: "small",
                          label: "Test phone number",
                          placeholder: "56912345678",
                          "prepend-inner-icon": "tabler:phone"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_unref(AButton), {
                          color: "blue",
                          "prepend-icon": "tabler:send",
                          disabled: !canSendTest.value,
                          loading: sendingTest.value,
                          onClick: testMessageTemplate
                        }, {
                          default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                            _createTextVNode(" Send test ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "loading"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _cache[68] || (_cache[68] = _createElementVNode("div", { class: "bsp-section-heading" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, "New template"),
                  _createElementVNode("p", null, "Define the content you'll submit to Meta for review.")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_67, [
                _createVNode(_unref(ASelector), {
                  modelValue: messageTemplateType.value,
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => ((messageTemplateType).value = $event)),
                    onTemplateTypeChange
                  ],
                  items: templateTypeOptions,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Template type"
                }, null, 8, ["modelValue"]),
                (isCreatingCatalogTemplate.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_68, " Catalog templates use Marketing, a message body, an optional footer, and a fixed View catalog button. Switching to catalog removes custom headers and other buttons. "))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AInput), {
                  modelValue: messageTemplateName.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((messageTemplateName).value = $event)),
                  label: "Name",
                  placeholder: "my_template"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ASelector), {
                  modelValue: messageTemplateLanguage.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((messageTemplateLanguage).value = $event)),
                  items: languageOptions,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Language",
                  placeholder: "Select a language"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ASelector), {
                  modelValue: messageTemplateCategory.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((messageTemplateCategory).value = $event)),
                  items: categoryOptions,
                  "item-title": "title",
                  "item-value": "value",
                  label: "Category",
                  placeholder: "Select a category",
                  disabled: isCreatingCatalogTemplate.value
                }, null, 8, ["modelValue", "disabled"]),
                _cache[67] || (_cache[67] = _createElementVNode("span", { class: "bsp-form-label" }, "Components", -1)),
                _createElementVNode("div", _hoisted_69, [
                  (headerComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("span", _hoisted_73, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:layout-navbar",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[47] || (_cache[47] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Header"),
                              _createElementVNode("p", null, "Optional content that appears before the message.")
                            ], -1))
                          ]),
                          (!isCreatingCatalogTemplate.value)
                            ? (_openBlock(), _createBlock(_unref(AButton), {
                                key: 0,
                                icon: "tabler:x",
                                variant: "text",
                                size: "small",
                                "help-text": "Remove header",
                                "aria-label": "Remove header",
                                onClick: removeHeaderComponent
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_unref(ASelector), {
                          modelValue: headerComponent.value.format,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((headerComponent.value.format) = $event)),
                          items: headerFormatOptions,
                          "item-title": "title",
                          "item-value": "value",
                          label: "Format",
                          size: "small"
                        }, null, 8, ["modelValue"]),
                        (headerComponent.value.format === 'TEXT')
                          ? (_openBlock(), _createBlock(_unref(AInput), {
                              key: 0,
                              modelValue: headerComponent.value.text,
                              "onUpdate:modelValue": [
                                _cache[12] || (_cache[12] = ($event: any) => ((headerComponent.value.text) = $event)),
                                _cache[13] || (_cache[13] = ($event: any) => (headerComponent.value && onHeaderTextInput(headerComponent.value)))
                              ],
                              type: "textarea",
                              rows: 3,
                              size: "small",
                              label: "Header text",
                              placeholder: "Write the header"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (headerComponent.value.format === 'TEXT' && headerComponent.value.example)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "bsp-template-field-caption" }, "Variable examples", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerComponent.value.example.header_text, (parameter, parameterIndex) => {
                                return (_openBlock(), _createBlock(_unref(AInput), {
                                  key: parameterIndex,
                                  modelValue: headerComponent.value.example.header_text[parameterIndex],
                                  "onUpdate:modelValue": ($event: any) => ((headerComponent.value.example.header_text[parameterIndex]) = $event),
                                  size: "small",
                                  label: `Variable {{${parameterIndex + 1}}}`,
                                  placeholder: "Example value"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerComponent.value.format))
                          ? (_openBlock(), _createBlock(_unref(AInput), {
                              key: 2,
                              modelValue: headerComponent.value.text,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((headerComponent.value.text) = $event)),
                              type: "url",
                              size: "small",
                              label: "Sample file URL",
                              placeholder: "https://...",
                              "prepend-inner-icon": "tabler:link"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (headerComponent.value.format === 'LOCATION')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:map-pin",
                                color: "info",
                                size: "17"
                              }),
                              _cache[49] || (_cache[49] = _createTextVNode(" The location will be completed when preparing the message. ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (bodyComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("span", _hoisted_79, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:text-caption",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[50] || (_cache[50] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Body"),
                              _createElementVNode("p", null, "Main content the recipient will receive.")
                            ], -1))
                          ]),
                          (!isCreatingCatalogTemplate.value)
                            ? (_openBlock(), _createBlock(_unref(AButton), {
                                key: 0,
                                icon: "tabler:x",
                                variant: "text",
                                size: "small",
                                "help-text": "Remove body",
                                "aria-label": "Remove body",
                                onClick: removeBodyComponent
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_unref(AInput), {
                          modelValue: bodyComponent.value.text,
                          "onUpdate:modelValue": [
                            _cache[15] || (_cache[15] = ($event: any) => ((bodyComponent.value.text) = $event)),
                            _cache[16] || (_cache[16] = ($event: any) => (bodyComponent.value && onBodyTextInput(bodyComponent.value)))
                          ],
                          type: "textarea",
                          rows: 4,
                          size: "small",
                          label: "Message",
                          placeholder: "Write the template content"
                        }, null, 8, ["modelValue"]),
                        (bodyComponent.value.example)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                              _cache[51] || (_cache[51] = _createElementVNode("span", { class: "bsp-template-field-caption" }, "Variable examples", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bodyComponent.value.example.body_text[0], (parameter, parameterIndex) => {
                                return (_openBlock(), _createBlock(_unref(AInput), {
                                  key: parameterIndex,
                                  modelValue: bodyComponent.value.example.body_text[0][parameterIndex],
                                  "onUpdate:modelValue": ($event: any) => ((bodyComponent.value.example.body_text[0][parameterIndex]) = $event),
                                  size: "small",
                                  label: `Variable {{${parameterIndex + 1}}}`,
                                  placeholder: "Example value"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (buttonsComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("span", _hoisted_84, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:click",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Buttons", -1)),
                              _createElementVNode("p", null, _toDisplayString(isCreatingCatalogTemplate.value ? 'Opens the connected WABA catalog.' : 'Optional actions available below the message.'), 1)
                            ])
                          ]),
                          (!isCreatingCatalogTemplate.value)
                            ? (_openBlock(), _createBlock(_unref(AButton), {
                                key: 0,
                                icon: "tabler:x",
                                variant: "text",
                                size: "small",
                                "help-text": "Remove buttons",
                                "aria-label": "Remove buttons",
                                onClick: removeButtonsComponent
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (isCreatingCatalogTemplate.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:shopping-bag",
                                color: "primary",
                                size: "18"
                              }),
                              _cache[53] || (_cache[53] = _createTextVNode(" View catalog · WhatsApp translates the fixed button label for the recipient. ", -1))
                            ]))
                          : (buttonsComponent.value.buttons.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonsComponent.value.buttons, (button, buttonIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "bsp-template-button-editor",
                                    key: buttonIndex
                                  }, [
                                    _createElementVNode("div", _hoisted_87, [
                                      _createVNode(_unref(ATag), {
                                        text: buttonTypeLabel(button.type),
                                        color: "info",
                                        type: "secondary",
                                        pill: ""
                                      }, null, 8, ["text"]),
                                      _createVNode(_unref(AButton), {
                                        icon: "tabler:trash",
                                        color: "red",
                                        variant: "text",
                                        size: "small",
                                        "help-text": "Delete button",
                                        "aria-label": "Delete button",
                                        onClick: ($event: any) => (removeTemplateButton(buttonIndex))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    (button.type === 'QUICK_REPLY')
                                      ? (_openBlock(), _createBlock(_unref(AInput), {
                                          key: 0,
                                          modelValue: button.text,
                                          "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                          size: "small",
                                          label: "Button text",
                                          placeholder: "E.g. View options"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (button.type === 'PHONE_NUMBER')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_unref(AInput), {
                                            modelValue: button.text,
                                            "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                            size: "small",
                                            label: "Button text",
                                            placeholder: "E.g. Call"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                          _createVNode(_unref(AInput), {
                                            modelValue: button.phone_number,
                                            "onUpdate:modelValue": ($event: any) => ((button.phone_number) = $event),
                                            type: "tel",
                                            size: "small",
                                            label: "Phone number",
                                            placeholder: "56912345678"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (button.type === 'URL')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createVNode(_unref(AInput), {
                                            modelValue: button.text,
                                            "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                            size: "small",
                                            label: "Button text",
                                            placeholder: "E.g. Open website"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                          _createVNode(_unref(AInput), {
                                            modelValue: button.url,
                                            "onUpdate:modelValue": [($event: any) => ((button.url) = $event), ($event: any) => (onUrlButtonUrlInput(button))],
                                            type: "url",
                                            size: "small",
                                            label: "URL",
                                            placeholder: "https://..."
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(button.example, (parameter, parameterIndex) => {
                                            return (_openBlock(), _createBlock(_unref(AInput), {
                                              key: parameterIndex,
                                              modelValue: button.example[parameterIndex],
                                              "onUpdate:modelValue": ($event: any) => ((button.example[parameterIndex]) = $event),
                                              size: "small",
                                              label: `URL variable {{${parameterIndex + 1}}}`,
                                              placeholder: "Example value"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                          }), 128))
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (button.type === 'COPY_CODE')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                          _createVNode(_unref(AInput), {
                                            modelValue: button.text,
                                            "onUpdate:modelValue": ($event: any) => ((button.text) = $event),
                                            size: "small",
                                            label: "Button text",
                                            placeholder: "Copy code"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                          _createVNode(_unref(AInput), {
                                            modelValue: button.example[0],
                                            "onUpdate:modelValue": ($event: any) => ((button.example[0]) = $event),
                                            size: "small",
                                            label: "Sample code",
                                            placeholder: "PROMO2026"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _createVNode(_unref(AIcon), {
                                  icon: "tabler:info-circle",
                                  color: "info",
                                  size: "17"
                                }),
                                _cache[54] || (_cache[54] = _createTextVNode(" Add at least one button type using the options below. ", -1))
                              ])),
                        (!isCreatingCatalogTemplate.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _createVNode(_unref(AButton), {
                                size: "small",
                                variant: "outlined",
                                "prepend-icon": "tabler:message-reply",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (addQuickReplyButton(buttonsComponent.value)))
                              }, {
                                default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                  _createTextVNode("Quick reply", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_unref(AButton), {
                                size: "small",
                                variant: "outlined",
                                "prepend-icon": "tabler:phone",
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (addPhoneNumberButton(buttonsComponent.value)))
                              }, {
                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                  _createTextVNode("Phone number", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_unref(AButton), {
                                size: "small",
                                variant: "outlined",
                                "prepend-icon": "tabler:external-link",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (addUrlrButton(buttonsComponent.value)))
                              }, {
                                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                  _createTextVNode("URL", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_unref(AButton), {
                                size: "small",
                                variant: "outlined",
                                "prepend-icon": "tabler:copy",
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (addCopyCodeButton(buttonsComponent.value)))
                              }, {
                                default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                  _createTextVNode("Copy code", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (footerComponent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("span", _hoisted_93, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:layout-bottombar",
                                color: "primary",
                                size: "18"
                              })
                            ]),
                            _cache[59] || (_cache[59] = _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Footer"),
                              _createElementVNode("p", null, "Short supporting text at the end of the template.")
                            ], -1))
                          ]),
                          _createVNode(_unref(AButton), {
                            icon: "tabler:x",
                            variant: "text",
                            size: "small",
                            "help-text": "Remove footer",
                            "aria-label": "Remove footer",
                            onClick: removeFooterComponent
                          })
                        ]),
                        _createVNode(_unref(AInput), {
                          modelValue: footerComponent.value.text,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((footerComponent.value.text) = $event)),
                          type: "textarea",
                          rows: 2,
                          size: "small",
                          label: "Message footer",
                          placeholder: "E.g. Thank you for choosing us"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", null, [
                    _cache[60] || (_cache[60] = _createElementVNode("h3", null, "Add component", -1)),
                    _createElementVNode("p", null, _toDisplayString(isCreatingCatalogTemplate.value ? 'Add an optional footer to the catalog message.' : 'You can remove it and add it again without losing the rest of the form.'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    (!isCreatingCatalogTemplate.value && headerComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 0,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:layout-navbar",
                          onClick: addHeaderComponent
                        }, {
                          default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                            _createTextVNode("Header", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (bodyComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 1,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:text-caption",
                          onClick: addBodyComponent
                        }, {
                          default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                            _createTextVNode("Body", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (footerComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 2,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:layout-bottombar",
                          onClick: addFooterComponent
                        }, {
                          default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                            _createTextVNode("Footer", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!isCreatingCatalogTemplate.value && buttonsComponent.value === undefined)
                      ? (_openBlock(), _createBlock(_unref(AButton), {
                          key: 3,
                          size: "small",
                          variant: "outlined",
                          "prepend-icon": "tabler:click",
                          onClick: addButtonsComponent
                        }, {
                          default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                            _createTextVNode("Buttons", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (headerComponent.value && bodyComponent.value && footerComponent.value && buttonsComponent.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_96, [
                          _createVNode(_unref(AIcon), {
                            icon: "tabler:circle-check",
                            color: "success",
                            size: "16"
                          }),
                          _cache[65] || (_cache[65] = _createTextVNode(" All components have been added ", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (isCreatingCatalogTemplate.value && catalogCreationError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(catalogCreationError.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AButton), {
                  color: "blue",
                  block: "",
                  "prepend-icon": "tabler:send",
                  onClick: createMessageTemplate,
                  disabled: creatingTemplate.value || !validTemplate(),
                  loading: creatingTemplate.value
                }, {
                  default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                    _createTextVNode(" Create and submit for review ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
  ]))
}
}

})